import { Component, Inject, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { IconDefinition, faArrowLeftLong, faXmark, faPrint } from '@fortawesome/free-solid-svg-icons';
import { DxReportViewerComponent } from 'devexpress-reporting-angular';
import { TemplateEngine } from 'devexpress-reporting-angular/dx-report-viewer';
import { CommunicationService } from 'app/_services/communication.service';
import { AppComponent } from 'app/app.component';
import { RADService } from 'app/_services/rad.service';
import { ActionId } from 'devexpress-reporting/dx-webdocumentviewer';
import * as ko from 'knockout';
import { DxReportDesignerComponent} from 'devexpress-reporting-angular';

@Component({
  selector: 'app-report-component',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './report.component.html',
  styleUrls: [
    "./report.component.css",
    "../../../node_modules/devextreme/dist/css/dx.common.css",
    "../../../node_modules/devextreme/dist/css/dx.material.blue.light.css",
    "../../../node_modules/@devexpress/analytics-core/dist/css/dx-analytics.common.css",
    "../../../node_modules/@devexpress/analytics-core/dist/css/dx-analytics.material.blue.light.css",
    "../../../node_modules/@devexpress/analytics-core/dist/css/dx-querybuilder.css",
    "../../../node_modules/devexpress-reporting/dist/css/dx-webdocumentviewer.css",
    "../../../node_modules/devexpress-reporting/dist/css/dx-reportdesigner.css",
  ]
})
export class ReportComponent {
  //#region Fields & Icons
  @ViewChild(DxReportDesignerComponent, { static: false }) designer: DxReportDesignerComponent;
  getDesignerModelAction: string = 'DXXRD/GetDesignerModel';
  reportUrl: string;
  viewerMode: boolean = false;
  reportId: string;
  showReportPrinting: boolean = false;
  printList: any[] = [];
  selectedPrinter: any = undefined;
  @ViewChild('viewer', { static: false }) viewer!: DxReportViewerComponent;
  @ViewChild('mySvgTemplate') svg!: TemplateRef<{ data: any }>;
  printButtonHoveredOver: boolean = false;
  printingQueueDisabled = ko.observable(true);
  faArrowLeftLong: IconDefinition = faArrowLeftLong;
  faXmark: IconDefinition = faXmark;
  faPrint: IconDefinition = faPrint;
  //#endregion

  constructor(
    public app: AppComponent,
    @Inject('BASE_URL') public hostUrl: string,
    private _templateEngine: TemplateEngine,    
    public communicationService: CommunicationService,
    private radService: RADService) {
    this.communicationService.action_base_closeDialog$.subscribe(() => {
      this.showReportPrinting = false;
    });

    if (!localStorage.getItem('qx_userId')) {
      window.location.href = '/signin';
      return;
    }

    if (!localStorage.getItem('qx_report')) return;
    let result = JSON.parse(localStorage.getItem('qx_report'));
    this.reportUrl = `${result.reportId}?USERID=${localStorage.getItem('qx_userId')}`;
    this.reportId = result.reportId;
    this.viewerMode = true;
    if (result.lineId) this.reportUrl += `&ID=${result.lineId}`;
    localStorage.removeItem('qx_report');

    let userId = localStorage.getItem('qx_userId')!;
    let formData = this.app.buildForm(['userId', 'reportId'], [userId, this.reportId]);
    this.radService.getReportPrintingList(formData).subscribe({
      next: (data: any) => {
        this.printList = data;
      }, error: (errorLog) => { console.log(errorLog); }
    });
  }

  ngAfterViewInit(): void {  
    this._templateEngine.register('printingqueue', this.svg);    
  }

  back(): void {
    window.location.href = '/base';
  }

  customizeMenuActions(event: any): void {    
    let exportAction = event.args.GetById(ActionId.ExportTo);
    
    let printingQueueAction = {
      text: "",
      imageTemplateName: "printingqueue",
      visible: true,
      disabled: this.printingQueueDisabled,
      hasSeparator: false,
      clickAction: () => { this.showReportPrinting = true; }
    };

    if (exportAction) {
      let index = event.args.Actions.indexOf(exportAction);
      event.args.Actions.splice(index, 0, printingQueueAction);
    }
  }

  close(): void {
    this.showReportPrinting = false;
  }

  selectPrinter(event: any): void {
    this.selectedPrinter = event.srcElement.value == '0' ? undefined : event.srcElement.value.toString();
  }

  confirmAndPrint(): void {
    this.showReportPrinting = false;
    
    let userId = localStorage.getItem('qx_userId')!;
    if (this.viewerMode) {      
      this.viewer.bindingSender.PerformCustomDocumentOperation(`serverPrint|${this.selectedPrinter}|${this.reportId}|${userId}`, true).then(result => {
        result.succeeded ? this.app.alertSuccess('Report queued for printing') : this.app.alertError('Report could not be queued for printing');
      });
    } else {
      this.designer.GetPreviewModel().PerformCustomDocumentOperation(`serverPrint|${this.selectedPrinter}|${this.reportId}|${userId}`, true).then(result => {
        result.succeeded ? this.app.alertSuccess('Report queued for printing') : this.app.alertError('Report could not be queued for printing');
      });;
    }        
  }

  documentReady(): void {    
    this.printingQueueDisabled(false);
  }

  previewCustomizeMenuActions(event: any) {
    let actions = event.args.Actions;    

    let preview = null;
    let index = null;
    let printAction = actions.find(a => a.text == 'Export To');
    if (printAction) {
      preview = printAction.reportPreview;
      index = event.args.Actions.indexOf(printAction);
    }

    let printingQueueAction = {
      id: 'serverPrint',
      text: 'Server Print',
      imageClassName: 'dxrd-image-print-page',
      imageTemplateName: 'dxrd-svg-preview-print_page',
      visible: true,
      disabled: false,
      reportPreview: preview,
      clickAction: () => { this.showReportPrinting = true;  }
    };

    event.args.Actions.splice(index, 0, printingQueueAction);   
  }

  onReportOpened(event: any): void {    
    this.reportId = event.args.Url;
    if (!this.reportId) return;
    let userId = localStorage.getItem('qx_userId')!;
    let formData = this.app.buildForm(['userId', 'reportId'], [userId, this.reportId]);
    this.radService.getReportPrintingList(formData).subscribe({
      next: (data: any) => {
        this.printList = data;
      }, error: (errorLog) => { console.log(errorLog); }
    });
  }
}